import { IsEmail, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';

export class UserDto {
  @IsUUID()
  id!: string;

  @IsEmail()
  email!: string;

  @IsString()
  @IsOptional()
  birthdate?: string;

  @IsString()
  @IsOptional()
  firstName?: string;

  @IsString()
  @IsOptional()
  lastName?: string;

  @IsNumber()
  @IsOptional()
  patientId?: number;
}
